import _get from 'lodash/get';
import * as CallData from '../../../../data/callData.json';
import * as Page from '../../lib/page';
import l10n from '../../lib/reactPPl10nHelper';

const country = Page.getCountry();
const locale = Page.getAPILocalilty();

const contactPage = {
  contactUs: 'contactUs',
  callUs: 'callUs',
  email: 'email',
  success: 'success',
};

const chatBotContactTo = {
  email: 'email',
  call: 'call',
};

const chatBotQueryParams = {
  TOPIC_CODE: 'topic_code',
  TOPIC_KEY: 'topic_key',
};

const MODAL_TYPE = {
  message: 'message',
  login: 'login',
};

// Top reason for find quick answers
const suggestTopics = {
  callUs: 'HELPHUB_TOPCONTACTREASON',
  email: 'HELPHUB_TOPCONTACTREASON_EMAIL',
};

// Limitation Quick Answer topics numbers
const limit = {
  quickAnswers: 10,
};

// Get PayPalCredit Number and hour
const getPayPalCreditNumber = () => {
  const tmpCountry = typeof country === 'string' && country.toUpperCase();
  const tmpLocale = typeof locale === 'string' && locale;

  // Return PPC number only for English; not rosetta
  if (typeof tmpLocale !== 'string' || tmpLocale.indexOf('en') < 0) {
    return null;
  }

  const number = _get(CallData, `${tmpCountry}.${tmpLocale}.PayPal_Credit.CONTACT_INFO.phoneNumbers`);
  const hours = _get(CallData, `${tmpCountry}.${tmpLocale}.PayPal_Credit.CONTACT_INFO.Hours_of_Service_1`);

  return {
    number: Array.isArray(number) ? number[0] : '',
    hours,
  };
};

// PayPal Credit Phone number
const PayPayCredit = {
  number: (getPayPalCreditNumber() || {}).number,
  hours: (getPayPalCreditNumber() || {}).hours || l10n.getContent('smarthelp/callUs.callUsPanel.PPC.hours'),

  // Login User Account Type and country checker
  accountMapping: {
    us: 'TXN_CARD_BML',
    uk: 'OPEN_ENDED',
    gb: 'OPEN_ENDED',
  },
};

// Quick Answer Layer Name
const quickAnswerLayer = {
  layer1: 'layer1',
  layer2: 'layer2',
};

const chatType = {
  chatBot: 'chatBot',
  liveChat: 'liveChat',
};

// Hardcode Email privacy topic ref id
const privacyRefId = 'PRIV001';

const modalChannels = {
  chatBot: 'chatBot',
  liveChat: 'liveChat',
  defaultEmail: 'email',
  finalEmail: 'emailUs',
  call: 'callUs',
};

const stepUpChannels = {
  call: 'callUs',
  email: 'emailUs',
  messageUs: 'messageUs',
  chat: 'chat',
  chatBot: 'chatBot',
  liveChat: 'liveChat',
};

export default {
  contactPage,
  suggestTopics,
  limit,
  PayPayCredit,
  quickAnswerLayer,
  chatBotContactTo,
  chatType,
  privacyRefId,
  MODAL_TYPE,
  modalChannels,
  stepUpChannels,
  chatBotQueryParams,
};
